import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Form, Modal } from "react-bootstrap";
import { apiSaveNotification } from "../../api/ApiNotification";
import { apiDeleteUserByIdColidee, apiGetUsers } from "../../api/ApiUser";
import { useTranslation } from "react-i18next";
import { apiControlIdsColidee } from "../../api/ApiColidee";

const ComponentModaleNotifier = (props) => {
  const { t } = useTranslation();
  const { showModalNotif, setShowModalNotif, handleRecupDatas } = props;
  const { ReduxToken } = useSelector((state) => state.ReduxToken);

  const initialState = {
    title: "",
    datePeremption: "",
    importance: "normal",
    body: "",
    device_tokens: [],
  };

  const [state, setState] = useState(initialState);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const datePlus = (nbJours = 1) => {
    var futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + nbJours);
    var finalDate =
      futureDate.getFullYear() +
      "-" +
      (futureDate.getMonth() + 1 < 10 ? "0" : "") +
      (futureDate.getMonth() + 1) +
      "-" +
      (futureDate.getDate() < 10 ? "0" : "") +
      futureDate.getDate();

    return finalDate;
  };

  const checkEmail = (user) => {
    /* si le mail est dans la table des refuses alors on le degage */
    if (ReduxInstance.emailsRefuses.includes(user.email)) {
      // console.log("on refuse " + user.email + " car son mail est dans la liste des mails refuses");
      return false;
    }

    /* si le mail  a demande a ne pas recevoir les notifs de cette instance on le degage */
    if (user.blackList.includes(ReduxInstance._id)) {
      // console.log("on refuse " +user.email +" car il a demande a ne pas recevoir les notifs de cette instance");
      return false;
    }

    /* si le mail  a demande a un domaine autorise on le garde */
    if (ReduxInstance.domainesAutorises.includes(user.email.split("@").pop())) {
      // console.log("on accepte " + user.email + " car il a un domaine autorise");
      return true;
    }

    /* si le mail  a demande a un email autorise on le garde */
    if (ReduxInstance.emailsAutorises.includes(user.email)) {
      // console.log("on accepte " + user.email + " car il a un mail autorise");
      return true;
    }

    /* Si la personne est dans la liste des administreurs/souscripteurs  */
    if (
      ReduxInstance.adminColideeAccess.includes(user.email) ||
      ReduxInstance.adminProcessAccess.includes(user.email) ||
      ReduxInstance.adminStatAccess.includes(user.email) ||
      ReduxInstance.souscripteur === user.email
    ) {
      //console.log("on accepte " + user.email + " car il est dans la liste des administrateurs/souscripteurs");
      return true;
    }

    /* si aucune boucle ne matche, dans le doute on refuse le mail */
    return false;
  };

  const submitNotif = async () => {
    if (state.title && state.body && state.datePeremption) {
      const notifFinale = { ...state };
      notifFinale.title = ReduxInstance.entite + " - " + notifFinale.title;
      await apiSaveNotification(ReduxInstance._id, state);
      alert("notification envoyée à " + notifFinale.device_tokens.length + " terminaux");
      if (handleRecupDatas) handleRecupDatas();
      closeModale();
    } else {
      alert("merci de remplir tous les champs obligatoires");
    }
  };

  const initialiseDeviceToken = async () => {
    let allUsers = await apiGetUsers();
    let usersToNotify = allUsers.data.filter((user) => checkEmail(user));
    const deviceTokenToNotify = [];

    const idsColideeToVerify = [];
    usersToNotify.forEach((userToNotify) => {
      idsColideeToVerify.push(userToNotify.idColidee);
    });
    const myForm = new FormData();
    myForm.append("idsColideeToVerify", idsColideeToVerify);
    const retourColidee = await apiControlIdsColidee(ReduxToken, myForm);
    if (retourColidee.data.length) {
      retourColidee.data.forEach(async (userToDelete) => {
        usersToNotify = usersToNotify.filter((user) => user.idColidee != userToDelete.id);
        await apiDeleteUserByIdColidee(userToDelete.id);
      });
    }

    usersToNotify.forEach((userToNotify) => {
      deviceTokenToNotify.push(...userToNotify.deviceToken);
    });

    const uniqueDeviceTokenToNotify = [...new Set(deviceTokenToNotify)];
    setState({ ...state, device_tokens: uniqueDeviceTokenToNotify });
  };

  const closeModale = () => {
    setShowModalNotif(false);
  };

  useEffect(() => {
    initialState.datePeremption = datePlus();
    setState(initialState);
    if (showModalNotif) {
      initialiseDeviceToken();
    }
  }, [showModalNotif]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={showModalNotif} onHide={closeModale}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.ComponentModaleNotifier.titre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.titreNotif")} *</label>
          <Form.Control
            type="text"
            name="title"
            value={state.title}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.dateNotif")} *</label>
          <Form.Control
            type="date"
            min={datePlus(0)}
            name="datePeremption"
            value={state.datePeremption}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.importanceNotif")} *</label>
          <Form.Select
            name="importance"
            value={state.importance}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          >
            {/* <option value="verylow">{t("commun.form.label.importanceNotifTresBasse")}</option> */}
            {/* <option value="low">{t("commun.form.label.importanceNotifBasse")}</option> */}
            <option value="normal">{t("commun.form.label.importanceNotifNormale")}</option>
            <option value="high">{t("commun.form.label.importanceNotifHaute")}</option>
            {/* <option value="veryhigh">{t("commun.form.label.importanceNotifTresHaute")}</option> */}
          </Form.Select>
          <label className="mt-2">{t("commun.form.label.contenuNotif")} *</label>
          <Form.Control
            as="textarea"
            type="text"
            name="body"
            style={{ height: "200px" }}
            value={state.body}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" onClick={closeModale}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitNotif}>
          {t("commun.form.button.envoyerNotif")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ComponentModaleNotifier;
